<template>
    <div
        class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 justify-center"
    >
        <div
            v-for="(item, index) in base"
            v-show="!item.scope || $ability.hasPermission(item.scope)"
            :key="index"
            class="flex justify-center"
        >
            <button
                class="btn btn-stack-primary my-2 text-left min-h-32 h-full w-full flex flex-col justify-start"
                :class="
                    itemCurrent === item.id
                        ? 'border-4 border-stack-emphasis'
                        : ''
                "
                @click="selectItem(item.id)"
            >
                <div class="w-full flex justify-between items-center">
                    <span class="text-lg">{{ item.name }}</span>
                    <span>{{ item.icon || "🔍" }}</span>
                </div>
                <p class="mt-1">{{ item.description }}</p>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "CardsSelector",
    model: {
        prop: "itemCurrent",
        event: "change"
    },
    props: {
        itemCurrent: {
            default: () => "",
            type: String,
            require: true
        },
        base: {
            default: () => [],
            type: Array,
            require: true
        }
    },
    emits: ["change"],
    data: () => ({}),
    watch: {},
    methods: {
        selectItem(id) {
            this.$emit("change", id);
        }
    }
};
</script>
